<template>
<div class="">
    <button
      v-for="(rating) in ratings"
      :key="rating"
      @mouseenter="mouseenter(rating)" @mouseleave="mouseleave" @click="handleClick(rating)">
    <svg style="cursor:pointer;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21" height="21" viewBox="0 0 22 22">
    <defs>
        <linearGradient id="hjjki4lyrb" x1="100%" x2="0%" y1="97.699%" y2="-7.144%">
            <stop offset="0%"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
        <filter id="cc7scjkx9a" width="214.4%" height="217.1%" x="-57.2%" y="-58.5%" filterUnits="objectBoundingBox">
            <feOffset dx="2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.6512 0 0 0 0 0.66896 0 0 0 0 0.74 0 0 0 0.48 0"/>
            <feOffset dx="-2" dy="-2" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="3"/>
            <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2"/>
            <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.979166667 0 0 0 0 0.983333333 0 0 0 0 1 0 0 0 0.8 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="shadowMatrixOuter2"/>
            </feMerge>
        </filter>
        <filter id="7p3w1njpje" width="157.2%" height="158.5%" x="-28.6%" y="-29.3%" filterUnits="objectBoundingBox">
            <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="4"/>
            <feOffset dy="-4" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1"/>
            <feColorMatrix in="shadowInnerInner1" result="shadowMatrixInner1" values="0 0 0 0 0.921568627 0 0 0 0 1 0 0 0 0 0.968627451 0 0 0 0.88 0"/>
            <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="4"/>
            <feOffset dy="4" in="shadowBlurInner2" result="shadowOffsetInner2"/>
            <feComposite in="shadowOffsetInner2" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner2"/>
            <feColorMatrix in="shadowInnerInner2" result="shadowMatrixInner2" values="0 0 0 0 0.0941176471 0 0 0 0 0.478431373 0 0 0 0 0.360784314 0 0 0 0.4 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixInner1"/>
                <feMergeNode in="shadowMatrixInner2"/>
            </feMerge>
        </filter>
        <filter id="3c3jf1vhqc" width="171.5%" height="173.2%" x="-35.7%" y="-36.6%" filterUnits="objectBoundingBox">
            <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5"/>
            <feOffset dx="5" dy="5" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1"/>
            <feColorMatrix in="shadowInnerInner1" result="shadowMatrixInner1" values="0 0 0 0 0.650980392 0 0 0 0 0.670588235 0 0 0 0 0.741176471 0 0 0 1 0"/>
            <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="5"/>
            <feOffset dx="-5" dy="-5" in="shadowBlurInner2" result="shadowOffsetInner2"/>
            <feComposite in="shadowOffsetInner2" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner2"/>
            <feColorMatrix in="shadowInnerInner2" result="shadowMatrixInner2" values="0 0 0 0 0.980392157 0 0 0 0 0.984313725 0 0 0 0 1 0 0 0 0.629129903 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixInner1"/>
                <feMergeNode in="shadowMatrixInner2"/>
            </feMerge>
        </filter>
        <path id="8tsswak56a" d="M16.823 20.5c-.241 0-.483-.056-.708-.168l-5.621-2.81-5.622 2.81c-.553.276-1.216.206-1.697-.18-.482-.388-.695-1.02-.545-1.619l1.412-5.65L.266 8.717c-.324-.486-.354-1.11-.079-1.624.276-.514.812-.836 1.395-.836h4.769L9.078.803c.537-1.07 2.295-1.07 2.831 0l2.727 5.455h4.77c.583 0 1.119.322 1.395.836.275.514.245 1.138-.079 1.624l-3.776 4.164 1.412 5.651c.15.598-.063 1.231-.545 1.618-.286.23-.637.348-.99.348"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g>
                    <g>
                        <g transform="translate(-739 -370) translate(292 165) translate(296 112) translate(0 83) translate(151 10)">
                            <use v-if="checked(rating)" fill="#99FFD1" xlink:href="#8tsswak56a"/>
                            <use v-if="!checked(rating)" fill="#EBECF0" xlink:href="#8tsswak56a"/>
                            <use fill="url(#hjjki4lyrb)" fill-opacity=".4" style="mix-blend-mode:soft-light" xlink:href="#8tsswak56a"/>
                            <use v-if="!checked(rating)" fill="#000" filter="url(#3c3jf1vhqc)" xlink:href="#8tsswak56a"/>
                            <use v-if="checked(rating)" fill="#000" filter="url(#7p3w1njpje)" xlink:href="#5waj6cdbhd"/>
                            <path stroke="#FFF" stroke-linejoin="square" stroke-opacity=".4" d="M10.494.5c.211 0 .424.05.605.152.151.086.28.21.363.375h0l2.865 5.731h5.079c.2 0 .39.055.555.154.166.1.305.243.4.418.093.176.135.37.126.563-.01.181-.064.36-.163.52h0l-3.928 4.331 1.477 5.91c.051.205.04.416-.024.608-.065.192-.184.367-.35.5-.195.157-.435.237-.676.237h0l-6.329-3.036-5.845 2.922c-.19.094-.398.13-.6.108-.201-.021-.396-.1-.561-.232-.165-.132-.284-.307-.349-.5-.064-.191-.075-.402-.024-.607h0l1.477-5.91L.664 8.413c-.1-.16-.154-.339-.163-.52-.01-.192.033-.387.126-.562.095-.176.234-.32.4-.419.165-.099.356-.154.555-.154H6.66l2.865-5.73c.083-.166.212-.29.363-.376.182-.103.394-.152.606-.152z"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
  </button>
  </div>
</template>

<script>

export default {
  name: 'TsRating',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ratings: [1,2,3],
      grade: this.value
    }
  },
  computed: {
  },
  methods: {
    checked(rating) {
      return this.value >= rating
    },
    mouseenter(rating) {
      this.grade = this.value;
      this.$emit('input', rating);
    },
    mouseleave() {
      this.$emit('input', this.grade);
    },
    handleClick(rating) {
      this.grade = rating;
      this.$emit('input', rating);
    }
  }
};
</script>

<style>
</style>